var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { safeParse } from './util';
export var formatTime = function (date, format) {
    if (date == null) {
        return '';
    }
    var pad = function (n) { return n < 10 ? '0' + n : n; };
    var year = date.getFullYear(), yearShort = year.toString().substring(2), month = date.getMonth() + 1, monthPad = pad(month), dateInMonth = date.getDate(), dateInMonthPad = pad(dateInMonth), hour = date.getHours(), hourPad = pad(hour), minute = date.getMinutes(), minutePad = pad(minute), second = date.getSeconds(), secondPad = pad(second);
    return format
        .replace(/yyyy/g, year)
        .replace(/yy/g, yearShort)
        .replace(/MM/g, monthPad)
        .replace(/M/g, month)
        .replace(/DD/g, dateInMonthPad)
        .replace(/D/g, dateInMonth)
        .replace(/HH/g, hourPad)
        .replace(/H/g, hour)
        .replace(/mm/g, minutePad)
        .replace(/m/g, minute)
        .replace(/ss/g, secondPad)
        .replace(/s/g, second);
};
export var spliceDataFormat = function (fields, entities, rows) {
    /** 实体 Map */
    var entityMap = {};
    entities.forEach(function (e) { return entityMap[e.id] = e; });
    var needFormatPaths = [];
    fields.forEach(function (field) {
        var nowEntity = entities.find(function (e) { return e.id === field.entityId; });
        if (!nowEntity) {
            return;
        }
        var curField = nowEntity.fieldAry.find(function (f) { return f.id === field.fieldId; });
        if (!curField) {
            return;
        }
        var showFormat = curField.bizType === 'datetime' ? curField.showFormat : (['enum', 'json'].includes(curField.bizType) ? 'JSON' : undefined);
        if (showFormat) {
            needFormatPaths.push(__spreadArray(__spreadArray([], field.fromPath.map(function (f) { return ({ key: f.fieldName }); }), true), [{ key: curField.name, showFormat: showFormat }], false));
        }
    });
    var deepFormat = function (item, path) {
        if (!path.length || !item) {
            return;
        }
        var key = path[0].key;
        if (path.length === 1) {
            if (Array.isArray(item)) {
                item.forEach(function (i) {
                    if (path[0].showFormat === 'JSON') {
                        try {
                            i[key] = i[key] ? safeParse(i[key], i[key]) : i[key];
                        }
                        catch (e) { }
                    }
                    else {
                        i['_' + key] = i[key];
                        i[key] = i[key] && path[0].showFormat ? formatTime(new Date(i[key]), path[0].showFormat) : null;
                    }
                });
            }
            else {
                if (path[0].showFormat === 'JSON') {
                    try {
                        item[key] = item[key] ? safeParse(item[key], item[key]) : item[key];
                    }
                    catch (e) { }
                }
                else {
                    item['_' + key] = item[key];
                    item[key] = item[key] && path[0].showFormat ? formatTime(new Date(item[key]), path[0].showFormat) : null;
                }
            }
            return;
        }
        if (Array.isArray(item)) {
            item.forEach(function (i) {
                deepFormat(i, path.slice(1));
            });
        }
        else {
            deepFormat(item[key], path.slice(1));
        }
    };
    return Array.from(rows || []).map(function (item) {
        needFormatPaths.forEach(function (path) {
            deepFormat(item, path);
        });
        return item;
    });
};
